import React from 'react';
import { Paper, Typography } from '@material-ui/core';
import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';
import cx from 'classnames';

type Props = {
  className?: string;
  children: React.ReactNode;
  heading?: React.ReactNode;
};

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      display: 'flex',
      flexDirection: 'column',
      height: '100%',
      background: theme.palette.background.default,
      padding: theme.spacing(1, 1.5, 2),
      borderRadius: theme.spacing(1),
      textAlign: 'left',
    },
    typography: {
      paddingBottom: theme.spacing(1),
      fontSize: 'var(--s0)',
    },
  })
);

const Zone = ({ className, children, heading }: Props) => {
  const classes = useStyles();

  return (
    <Paper elevation={0} className={cx(classes.root, className)}>
      {heading && (
        <Typography className={classes.typography} variant="h6" color="primary">
          {heading}
        </Typography>
      )}
      {children}
    </Paper>
  );
};

export default Zone;
